import { Routes } from '@/app/routes';

// eslint-disable-next-line @typescript-eslint/ban-types
export type DefaultAppProps = {};
const DefaultApp = (props: DefaultAppProps) => {
  return (
    <>
      <Routes {...props} />
    </>
  );
};

export { DefaultApp };
